
  import React from "react"
  import Component from "/Users/danielmcmillan/Desktop/IMBIBE Work/imbibe 9:25:19/src/layouts/index.js"
  import data from "/Users/danielmcmillan/Desktop/IMBIBE Work/imbibe 9:25:19/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js